import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";

export function FAQAccordion({ items, idPrefix = "faq" }) {
  return (
    <Accordion type="single" collapsible className="w-full space-y-3">
      {items.map((it, i) => (
        <AccordionItem
          key={i}
          value={`item-${i}`}
          className="rounded-xl border border-hair bg-white px-5 shadow-sm data-[state=open]:border-finblue/30"
          data-testid={`${idPrefix}-item-${i}`}
        >
          <AccordionTrigger className="py-5 text-left font-heading text-base font-semibold text-ink hover:no-underline">
            {it.q}
          </AccordionTrigger>
          <AccordionContent className="pb-5 text-sm leading-relaxed text-subtle">{it.a}</AccordionContent>
        </AccordionItem>
      ))}
    </Accordion>
  );
}
